module.exports = __webpack_public_path__ + "img/horizontal_4_5_9016.5ad001a6.png";